import { useState } from 'react';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import { makeClassName } from '@siteless/util';

export let Tooltip = ({
  text = '',
  tooltipSide = 'top',
  tooltipAlign = 'center',
  children,
  className,
  contentClassName,
}: {
  text?: string;
  maxWidth?: number;
  tooltipSide?: 'top' | 'right' | 'bottom' | 'left';
  tooltipAlign?: 'start' | 'center' | 'end';
  children?: React.ReactNode;
  className?: string;
  contentClassName?: string;
} & React.HTMLAttributes<HTMLSpanElement>) => {
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);

  return (
    <TooltipPrimitive.Provider>
      <TooltipPrimitive.Root
        onOpenChange={(isOpen) => {
          setIsTooltipOpen(isOpen);
        }}
        open={isTooltipOpen}
      >
        <TooltipPrimitive.Trigger asChild>
          <div
            className={className}
            onClick={() => {
              setIsTooltipOpen(!isTooltipOpen);
            }}
          >
            {children}
          </div>
        </TooltipPrimitive.Trigger>
        <TooltipPrimitive.Portal>
          <TooltipPrimitive.Content
            side={tooltipSide}
            align={tooltipAlign}
            sideOffset={5}
            className={makeClassName(
              'text-neutral-0 z-50 max-w-xs whitespace-pre-line rounded bg-neutral-800 px-3 py-2 text-sm shadow-md',
              contentClassName,
            )}
          >
            {typeof children === 'string' ? children : text}
          </TooltipPrimitive.Content>
        </TooltipPrimitive.Portal>
      </TooltipPrimitive.Root>
    </TooltipPrimitive.Provider>
  );
};
